<template>
  <div class="todo-toolbar">
    <h2>功能菜单</h2>
    <!-- 添加搜索框 -->
    <div class="search-container">
      <input type="text" v-model="searchQuery" placeholder="搜索任务..." class="search-input" @input="handleSearch" />
    </div>
    <div class="toolbar-buttons">
      <button class="btn primary" @click="addTask">
        <i class="icon">+</i> 添加任务
      </button>
      <button class="btn secondary" @click="openSettings">
        <i class="icon">⚙️</i> 设置
      </button>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue'
import { useTodoStore } from '../stores/todoStore.js'

export default {
  name: 'TodoToolbar',
  setup() {
    const store = useTodoStore()
    const searchQuery = ref(store.searchQuery || '')

    // 监听搜索框的变化并更新store
    watch(searchQuery, (newQuery) => {
      store.searchQuery = newQuery
    })

    // 监听store中搜索查询的变化并更新本地ref
    watch(() => store.searchQuery, (newQuery) => {
      searchQuery.value = newQuery || ''
    })

    const addTask = () => {
      store.openAddTaskModal()
    }

    const openSettings = () => {
      store.openSettingsModal()
    }

    return {
      searchQuery,
      addTask,
      openSettings
    }
  }
}
</script>

<style scoped>
.todo-toolbar {
  padding: 20px;
}

.search-container {
  margin-bottom: 20px;
}

.search-input {
  width: 100%;
  padding: 10px 15px;
  border: 2px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.3s ease;
  box-sizing: border-box;
}

.search-input:focus {
  outline: none;
  border-color: #42b983;
}

.toolbar-buttons {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 20px;
}

.btn {
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.btn.primary {
  background: #42b983;
  color: white;
}

.btn.primary:hover {
  background: #359c6d;
}

.btn.secondary {
  background: #f0f0f0;
  color: #333;
}

.btn.secondary:hover {
  background: #e0e0e0;
}

.icon {
  font-size: 18px;
}
</style>